import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_FILL_OPACITY, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const NotificationBellIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  isFilled,
  fillOpacity = DEFAULT_FILL_OPACITY,
}) => {
  const path = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.05 2.25c.417 0 .755.344.755.769v1.12a6.742 6.742 0 0 1 4.048 1.985 6.992 6.992 0 0 1 1.99 4.895c0 2.842.297 4.45.568 5.32.134.433.26.676.334.795.031.05.053.079.062.09.22.206.3.529.2.82a.756.756 0 0 1-.712.514H4.805a.754.754 0 0 1-.679-.433.782.782 0 0 1 .083-.81l-.001.003-.003.003-.003.005a2.244 2.244 0 0 0 .118-.21c.091-.186.226-.501.364-.98.278-.96.573-2.578.573-5.117 0-1.836.716-3.597 1.99-4.895a6.742 6.742 0 0 1 4.048-1.985v-1.12c0-.425.338-.77.755-.77zm-1.823 17.262c.4-.12.82.114.937.522a.943.943 0 0 0 .333.489.914.914 0 0 0 1.11 0 .943.943 0 0 0 .333-.49.753.753 0 0 1 .936-.52c.4.119.63.546.512.954a2.483 2.483 0 0 1-.877 1.288 2.404 2.404 0 0 1-1.46.495 2.404 2.404 0 0 1-1.458-.495 2.483 2.483 0 0 1-.877-1.288.772.772 0 0 1 .511-.955z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.05 2.25c.417 0 .755.344.755.769v1.12a6.742 6.742 0 0 1 4.048 1.985 6.992 6.992 0 0 1 1.99 4.895c0 2.842.297 4.45.568 5.32.134.433.26.676.334.795.031.05.053.079.062.09.22.206.3.529.2.82a.756.756 0 0 1-.712.514H4.805a.754.754 0 0 1-.679-.433.782.782 0 0 1 .083-.81v.001l-.001.002-.003.003-.003.004a.02.02 0 0 0-.001.002v-.001a2.244 2.244 0 0 0 .118-.21c.092-.186.227-.501.365-.98.278-.96.573-2.578.573-5.117 0-1.836.716-3.597 1.99-4.895a6.742 6.742 0 0 1 4.048-1.985v-1.12c0-.425.338-.77.755-.77zM5.99 17.02h12.052a7.686 7.686 0 0 1-.07-.215c-.333-1.07-.64-2.846-.64-5.786a5.438 5.438 0 0 0-1.546-3.808 5.233 5.233 0 0 0-3.736-1.577 5.233 5.233 0 0 0-3.736 1.577 5.438 5.438 0 0 0-1.547 3.808c0 2.659-.309 4.426-.635 5.552a9.549 9.549 0 0 1-.141.448zm4.237 2.492c.4-.12.82.114.937.522a.943.943 0 0 0 .333.489.914.914 0 0 0 1.11 0 .943.943 0 0 0 .333-.49.753.753 0 0 1 .936-.52c.4.119.63.546.512.954a2.483 2.483 0 0 1-.877 1.288 2.404 2.404 0 0 1-1.46.495 2.404 2.404 0 0 1-1.458-.495 2.483 2.483 0 0 1-.877-1.288.772.772 0 0 1 .511-.955z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper viewBox={viewBox} size={size} fill="none">
      {path}
    </SvgWrapper>
  )
}

export default NotificationBellIcon
